import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../App.css';
import './IndexPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import CarrosselFotos from '../../components/CarrosselFotos/CarrosselFotos';
import { useAviso } from "../../hooks/useAviso";

import unhas        from '../../assets/fotos/unhas.jpg';
import sobrancelhas from '../../assets/fotos/sobrancelhas.jpg';
import depilacao     from '../../assets/fotos/depilacao.jpg';
import produtos     from '../../assets/fotos/produtos.jpg';

import localizacao from '../../assets/img/localizacao.png';

export default function IndexPage(){

    const { avisos, loading, erro } = useAviso([1, 2]);

  return (
    <div className="IndexPage-container">
        <Header/>
        
        <article>
            <div className="Index">
                <CarrosselFotos />

                <h2>Informações sobre o local</h2><br/>
                <p>
                    Oferecemos serviços de beleza em um espaço acolhedor, moderno e profissional, 
                    pensado para atender às suas necessidades com qualidade e atenção.<br/>
                    Nosso objetivo é proporcionar uma experiência agradável, com cuidado e dedicação em cada detalhe. 
                </p>

                <div className="Index-imagens">
                    <div className="Index-imagens-local">
                    <img src={unhas} alt="Unhas" />
                    </div>
                    <div className="Index-imagens-local">  
                    <img src={sobrancelhas} alt="Sobrancelhas" />   
                    </div>
                    <div className="Index-imagens-local">
                    <img src={depilacao} alt="depilação" />
                    </div>
                </div>

                <div className="Index-produtos">
                    <h2>Informações sobre produtos</h2><br/>
                    <p>
                        Trabalhamos com produtos de alta qualidade, 
                        selecionados para garantir resultados excepcionais e atender às suas expectativas.
                        <br/><br/>
                        Além disso, oferecemos trabalhamos com venda de produtos, ideais para manter os cuidados 
                        em casa com a mesma excelência que você encontra aqui 
                    </p>

                    <div className="Index-produtos-imagens">
                        <img src={produtos} alt="produtos" />
                    </div>
                </div>
                

                <div className="Index-agendamento">
                    <h2>Informações sobre agendamento</h2><br/>
                    <p>
                        Disponibilizamos um sistema de agendamento prático e eficiente, 
                        pensado para oferecer maior conveniência e organização ao planejar seus cuidados.<br/><br/>
                        <span>Clique <Link to="/Agendamentos"><strong>aqui</strong></Link> para realizar seu agendamento.</span>
                    </p>
                </div>

                <div className="Index-exibe-horario">
                    <div className="Index-horario">
                    <h2>Horário de atendimento</h2><br/>

                        {avisos[0] && <p>{avisos[0].DESCRICAO}</p>}
                        {avisos[1] && <p>{avisos[1].DESCRICAO}</p>}

                    </div>    
                </div>

                <div className ="Index-post">

                </div>                    

                <div className="Index-como-chegar">
                    <div className="Index-endereco">
                        <img src={localizacao} alt="Localização" />
                        <br/>
                        <div>
                            <strong>Rua:</strong> Tv. Atílio Marino, 205<br/> 
                            <strong>Bairro:</strong> Vila Nossa Sra. de Fatima<br/>
                            <strong>Cep:</strong> 13567-220<br/>
                            <strong>Cidade:</strong> São Carlos/SP<br/>
                        </div>
                        <br/>
                        <a href="https://www.google.com/maps?q=-22.007191,-47.871802" rel="noopener noreferrer" target="_blank" className   ="Index-botao-mapa" >Abrir no Google Maps</a>
                    </div>
                    <div className="Index-mapa">
                        <iframe
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src="https://www.google.com/maps?q=-22.007191,-47.871802&output=embed">
                        </iframe>
                    </div>
                </div>
            </div>
        </article> 

        <Footer />
    </div>
  );  
}